import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import AppTools from 'utils/app/appTools'

import Home from 'pages/Home'
import CompetitivenessGeneralDashboard from 'pages/CompetitivenessGeneralDashboard'
import IndicatorsPerformance from 'pages/IndicatorsPerformance'
import IndicatorDetail from 'pages/IndicatorDetail'
import IndicatorEvolutionPage from 'pages/IndicatorEvolutionPage'
import IndicatorEvolutionEmbedPage from 'pages/IndicatorEvolutionEmbedPage'
import PanelsDevelopmentMethodology from 'pages/PanelsDevelopmentMethodology'
import ReportTablePage from 'pages/ReportTablePage'

import Config from 'utils/config'

const App = () => {

  const defaultLanguage = AppTools.getDefaultLanguage()
  const BASE_PATH = Config.getConfig().site.path
  return (
    <Switch>
      <Redirect from={BASE_PATH} exact to={BASE_PATH + '/' + defaultLanguage} />

      <Route path={BASE_PATH + '/:lang/panels-development-methodology'} exact component={PanelsDevelopmentMethodology} />

      <Redirect from={BASE_PATH + '/:lang/:regionCode'} exact to={BASE_PATH + '/:lang/:regionCode/dashboard'} />

      <Route path={BASE_PATH + '/:lang/'} exact component={Home} />
      <Route path={BASE_PATH + '/:lang/:regionCode/dashboard'} exact component={CompetitivenessGeneralDashboard} />
      <Route path={BASE_PATH + '/:lang/:regionCode/report-table'} exact component={ReportTablePage} />
      <Route path={BASE_PATH + '/:lang/:regionCode/group-detail/:level'} exact component={IndicatorsPerformance} />
      <Route path={BASE_PATH + '/:lang/:regionCode/indicator-detail/:indicatorId'} exact component={IndicatorDetail} />

      <Route path={BASE_PATH + '/:lang/:regionCode/indicator-evo/:indicatorId'} exact component={IndicatorEvolutionPage} />
      <Route path={BASE_PATH + '/:lang/:regionCode/indicator-evo/:indicatorId/embed'} exact component={IndicatorEvolutionEmbedPage} />
    </Switch>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/setup/App.jsx